import { useEffect, useRef, useState } from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { List } from "react-bootstrap-icons";

export default function OverflowToolbar({ items }) {
    const containerRef = useRef(null);
    const [overflowItems, setOverflowItems] = useState([]);

    useEffect(() => {
        if (!containerRef.current) return;

        const updateLayout = () => {
            requestAnimationFrame(() => {
                const el = containerRef.current;
                if (!el) return;

                const maxWidth = el.clientWidth - 100; // 100px برای دکمه منو
                const btnElements = el.querySelectorAll(".toolbar-btn");
                const newOverflow = [];
                let sumWidth = 0;

                btnElements.forEach((btn, i) => {
                    btn.style.display = "inline-flex";
                    const btnWidth = btn.offsetWidth;
                    sumWidth += btnWidth;
                    if (sumWidth > maxWidth) {
                        btn.style.display = "none";
                        newOverflow.push(items[i]);
                    }
                });

                setOverflowItems(newOverflow);
            });
        };

        const observer = new ResizeObserver(updateLayout);
        observer.observe(containerRef.current);

        updateLayout(); // اجرای اولیه

        return () => observer.disconnect();
    }, [items]);
    const popMenu = (
        <Popover id="popMenu" style={{ fontFamily: "Vazir" }}>
            <Popover.Title className="headerStyle" style={{ paddingRight: "2px" }}><List size={18} /> سایر عملیات</Popover.Title>
            <Popover.Content className="bodyStyle" style={{ padding: "2px" }}>
                {overflowItems.map((item, index) => (
                    item && <div className="popMenuItem"
                        key={item.key || index}
                        onClick={item.onClick}
                    >
                        {item.icon && <span>{item.icon}</span>}
                        {item.label && <span>{item.label}</span>}
                    </div>
                ))}

            </Popover.Content>
        </Popover>
    )
    return (
        <div ref={containerRef} style={{ display: "flex", gap: "5px", overflow: "hidden", paddingBottom: "5px" }}>
            {items.map((item, index) => (
                <Button
                    type={item.type || "button"}
                    key={item.key || index}
                    variant={item.variant || "primary"}
                    className={`group-Btn toolbar-btn ${item.className}`}
                    onClick={item.onClick}
                    style={{ display: "inline-flex", gap: "1px", alignItems: "center", flexShrink: 0 }}
                >
                    {item.icon && <span>{item.icon}</span>}
                    {item.label && <span>{item.label}</span>}
                </Button>
            ))}
            {overflowItems.length > 0 && (
                <OverlayTrigger trigger="click" rootClose overlay={popMenu}>
                    <Button className="group-Btn btn-violet"><List size={18} /></Button>
                </OverlayTrigger>
            )}
        </div>
    );
}
